export default __webpack_public_path__ + "static/media/idmission.c23bcf38.png";